<template>
  <div>
    <!-- Includes section -->
    <ul class="list-none paragraph-1 gap-y-3">
      <li class="flex flex-row items-center gap-x-1">
        <Check class="fill-primary size-4 shrink-0 self-start mt-[3px]" />
        <div>Everything in Free plan</div>
      </li>
    </ul>

    <!-- Features section -->
    <ul class="list-none mt-3 paragraph-1 gap-y-3">
      <li v-for="(feature, index) in stringFeatures" :key="`annual-feature-${index}`">
        <Plus class="fill-primary size-4 inline-block mr-2" />{{ feature }}
      </li>

      <!-- Retirement planning list feature -->
      <li>
        <Plus class="fill-primary size-4 inline-block mr-2" />Retirement planning
        <UnorderedList
          :items="[
            'Retirement income goals',
            'Downsizing strategy',
            'Extra contributions strategy',
            'Income projections with age pension',
          ]"
          class="mt-2 ml-4" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import Check from '@/components/SVGS/BrandIcons/16px/tick.svg'
import Plus from '@/components/SVGS/BrandIcons/16px/add.svg'
import UnorderedList from '@/app/components/common/UnorderedList.vue'

const stringFeatures = [
  'Life plan and Wealth Health checker',
  'Super contributions + salary sacrifice advice',
  'Personal insurance advice',
  'Debt management advice',
]
</script>
